import { FC, useCallback } from "react";
import cn from "classnames";
import { Tag, Paragraph, useGetURLQuery, ActionBar } from "capitalrx-components-2.0";
import { useAlert } from "capitalrx-components-2.0/lib/general";
import { QueryParams } from "@/types/QueryParams";
import styles from "./FindBestPriceActionBar.module.scss";

const FindBestPriceActionBar: FC = () => {
  const showAlert = useAlert();

  const failureHandler = useCallback(
    (err: string | Error): void => {
      showAlert({ type: "error", message: typeof err === "string" ? err : err.message, style: "banner" });
    },
    [showAlert],
  );

  const getURLQuery = useGetURLQuery<QueryParams>(failureHandler);
  const { dosage, drug_name, dosage_form, zipcode, quantity } = getURLQuery;

  const searchSummaryNoMobile = cn(styles["SearchSummary"], "NoMobile", { [styles["Hide"]]: drug_name === undefined });

  return (
    <ActionBar drugName={drug_name} testId="advantage-action-bar">
      <div className={searchSummaryNoMobile}>
        <div className={styles.SearchSummaryAttributes}>
          <Paragraph size="small">BEST PRICE FOR:</Paragraph>
          <div>
            <Tag size="small" type="solid" theme="light" className={styles.ActionBarTag} testId="searched-drug-name">
              {drug_name}
            </Tag>

            <Tag size="small" type="solid" theme="light" className={styles.ActionBarTag} testId="searched-drug-dosage">
              {dosage}
            </Tag>

            <Tag size="small" type="solid" theme="light" className={styles.ActionBarTag} testId="searched-drug-form">
              {dosage_form}
            </Tag>

            <Tag size="small" type="solid" theme="light" className={styles.ActionBarTag} testId="searched-drug-quantity">
              {quantity}
            </Tag>
          </div>
        </div>
        <div className={styles.SearchSummaryLocation} data-testid="searched-location">
          <Paragraph size="small">LOCATION</Paragraph>
          <Tag size="small" type="solid" theme="light" className={styles.ActionBarTag} testId="searched-zipcode">
            {zipcode}
          </Tag>
        </div>
      </div>
    </ActionBar>
  );
};

export default FindBestPriceActionBar;
